import Api from '../Base'

class GetUserSelf extends Api {
  requestUrl = '/api/user/self'
}

export default GetUserSelf
